/* eslint-disable */
import $ from 'jquery';
import ko from 'knockout';
import Base from '@bingads-webui-static-legacy/bulk-edit/viewmodel/bulkEditJob';
import campaignStatus from '@bingads-webui-static-legacy/schema/campaign/status';
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!global');
var ViewModel = function (model) {
  Base.call(this);
  var status = model.get('BatchAction').Actions[0].Value;
  this.showPanel = true;
  this.selectedEntityCount(model.get('selectedEntityCount'));
  this.titleText = ko.computed(function () {
    if (status === campaignStatus.Deleted) {
      return i18n.getString('BulkEdit_Campaign_DeleteTitle').replace('{0}', this.selectedEntityCount());
    } else if (status === campaignStatus.Active) {
      return i18n.getString('BulkEdit_Campaign_ResumeTitle').replace('{0}', this.selectedEntityCount());
    } else {
      return i18n.getString('BulkEdit_Campaign_PauseTitle').replace('{0}', this.selectedEntityCount());
    }
  }, this);
  this.validate = function () {
    this.errorMessage('');
    if (this.selectedEntityCount() === 0) {
      alert(i18n.getString('Grid_RowSelectionRequired'));
      return false;
    }
    return true;
  };
};
export default ViewModel;

